
/**
 * @description user模块内容注册
 */


/************************************** Module ***********************************************/

import { CommonModule } from '../common/common.module';

import { name as accessor } from "@modules/accessor/accessor.module";


/************************************** Service ***********************************************/

import { AnonymousUserRestService } from './rest/anonymous-user-rest.service';

import { AuthorizationUserRestService } from './rest/authorization-user-rest.service';

import { AddressRestService } from './rest/address/address-rest.service';

import { CountryRestService } from './rest/country/country-rest.service';

import { PartnerRestService } from './rest/partner/partner-rest.service';

import { PartnerRestService as PartnerRestServiceV2 } from './rest/partner/partner-rest-service.service';

import { AddressService } from './service/address/address.service';


import { UserRestService } from './rest/account/user-rest.service';


/************************************** Config ***********************************************/

import { AnonymousRestConfig } from './rest/anonymous-rest.service.config';


import { AddressRestServiceConfig } from './rest/address/address-rest.service.config';

import { CountryRestServiceConfig } from './rest/country/country-rest.service.config';

import { PartnerRestServiceConfig } from './rest/partner/partner-rest.service.config';

import { PartnerRestServiceConfig as PartnerRestServiceConfigV2 } from './rest/partner/partner-rest-service.config';

import { UserRestServiceConfig } from './rest/account/user-rest.service.config';
import { AuthorizationRestConfigV2 } from './rest/authorization-user-rest-v2.service.config';
import { AnonymousUserRestConfig } from './rest/anonymous-user-rest.config';
import { AuthorizationUserRestV2Service } from './rest/authorization-user-rest-v2.service';
import { AuthorizationRestConfig } from './rest/authorization-user-rest.service.config';
import { RestfulAccessorProvider } from '@core/data-access/restful';
import { AnonymousRestService } from './rest/anonymous-user-rest-service';

/************************************** 内容注册 ***********************************************/

let userModule = angular.module("qpmn-user", [CommonModule.name, accessor])

userModule.service({
    anonymousUserRestService: AnonymousUserRestService,
    anonymousRestService: AnonymousRestService,
    authorizationUserRestService: AuthorizationUserRestV2Service,
    addressRestService: AddressRestService,
    countryRestService: CountryRestService,
    partnerRestService: PartnerRestService,
    addressService: AddressService,
    userRestService: UserRestService,

    partnerRestServiceV2: PartnerRestServiceV2
});

userModule.config(["$restProvider", "$accessorProvider",
    function ($restProvider, $accessorProvider: RestfulAccessorProvider) {
        $restProvider.configs(AnonymousRestConfig);
        $restProvider.configs(AuthorizationRestConfig);

        $restProvider.configs(PartnerRestServiceConfig);

        $restProvider.configs(UserRestServiceConfig);
        $restProvider.configs(AddressRestServiceConfig);
        $restProvider.configs(CountryRestServiceConfig);


        /****************** 新版本REST结构 ********************/
        $accessorProvider.config(AuthorizationRestConfigV2);
        $accessorProvider.config(AnonymousUserRestConfig);

        $accessorProvider.config(PartnerRestServiceConfigV2);
    }
])


export { userModule }